import * as Yup from 'yup';

const personEmploymentSchema = Yup.object({
  ptsPlaceID: Yup.number().nullable().required('Employer is required'),

  DepartmentName: Yup.string().nullable().max(40, 'Department Name cannot exceed 40 characters'),

  Shift: Yup.string().nullable().max(50, 'Shift cannot exceed 50 characters'),

  Notes: Yup.string().nullable().max(2000, 'Notes cannot exceed 2000 characters'),
});

export default personEmploymentSchema;
